import { EntriesClient } from "~/api/entries";
import type { QueryKey } from "@tanstack/vue-query";

export const schemaMutations = () => {
  const queryClient = useQueryClient();
  const entriesClient = useApiClient(EntriesClient);
  const toast = useToast();
  const { entries, fieldOfLaws, paragraphs } = queries();

  const togglePublishedMutation = useMutation({
    mutationFn: ({ id, publish }: { id: number; publish: boolean }) => {
      if (publish) {
        return entriesClient.publishSchema(id);
      } else {
        return entriesClient.unpublishSchema(id);
      }
    },
    onError: (_, { publish }) => {
      toast.error(
        `Schema konnte nicht ${
          publish ? "veröffentlicht" : "versteckt"
        } werden.`
      );
    },
    onSuccess: (data) => {
      queryClient.setQueryData(
        entries.byType("schema")._ctx.byId(data.id).queryKey,
        data
      );

      if (data.slug) {
        queryClient.setQueryData(
          entries.byType("schema")._ctx.bySlug(data.slug).queryKey,
          data
        );
      }

      const invalidationKeys: QueryKey[] = [
        paragraphs
          .byId(data.legal_text_paragraph_id)
          ._ctx.entriesByParagraph("schema").queryKey,
      ];

      const folId = data.legal_text_paragraph.field_of_law_primary_id;
      if (folId) {
        invalidationKeys.push(fieldOfLaws.byId(folId)._ctx.schemas.queryKey);
      }

      return invalidateKeys(queryClient, invalidationKeys);
    },
  });

  return { togglePublishedMutation };
};
